import React from "react";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const ImageComponent = ({
    elementKey,
    colorPicker,
    idQuestion,
    setQualification,
    selectImage,
    internalCode,
    typeQuestion,
}) => {
    switch (selectImage) {
        case "star":
            return (
                <StarRoundedIcon
                    key={elementKey}
                    className="icon-selected-Survey-answer ImageRating"
                    onClick={() =>
                        setQualification({
                            elementKey,
                            selectImage,
                            idQuestion,
                            internalCode,
                            typeQuestion,
                        })
                    }
                    style={{ fill: colorPicker }}
                ></StarRoundedIcon>
            );
        case "heart":
            return (
                <FavoriteRoundedIcon
                    key={elementKey}
                    className="icon-selected-preview ImageRating"
                    onClick={() =>
                        setQualification({
                            elementKey,
                            selectImage,
                            idQuestion,
                            internalCode,
                            typeQuestion,
                        })
                    }
                    style={{ fill: colorPicker }}
                ></FavoriteRoundedIcon>
            );
        default:
            return (
                <Form.Check
                    inline
                    label={elementKey}
                    type="radio"
                    id={`number-${elementKey}`}
                    name={`number-${idQuestion}`}
                    onClick={() =>
                        setQualification({
                            elementKey,
                            selectImage,
                            idQuestion,
                            internalCode,
                            typeQuestion,
                        })
                    }
                />
            );
    }
};

export default ImageComponent;

ImageComponent.propTypes = {
    elementKey: PropTypes.string,
    idQuestion: PropTypes.string,
    internalCode: PropTypes.array,
    typeQuestion: PropTypes.string,
    colorPicker: PropTypes.string,
    setQualification: PropTypes.func,
    selectImage: PropTypes.string,
  }